import { gql } from '@apollo/client';
import { Typography, useTheme } from '@mui/material';
import { Image } from '@realadvisor/image';
import { Building2Icon } from 'lucide-react';

import type { OrganisationCell_OrganisationFragment } from '@graphql/__generated__/graphql';

export const ORGANISATION_CELL_FRAGMENT = gql`
  fragment OrganisationCell_organisation on organisations {
    id
    name
    street
    street_number
    postcode
    locality
    organisation_images(where: { is_primary: { _eq: true } }, limit: 1) {
      image {
        url
      }
    }
  }
`;

interface OrganisationCellProps {
  organisation?: OrganisationCell_OrganisationFragment;
}

export const OrganisationCell = ({ organisation }: OrganisationCellProps) => {
  const theme = useTheme();
  const { text } = theme;
  // Prefer CSS-variable palette so colors follow the active color scheme.
  const palette = (theme.vars ?? theme).palette;
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'max-content 1fr',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <div style={{ position: 'relative' }}>
        <div
          style={{
            height: 50,
            width: 75,
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {(organisation?.organisation_images?.length || 0) > 0 ? (
            <Image
              src={organisation?.organisation_images[0]?.image.url ?? ''}
              options={{ w: 256, f: 'jpg' }}
              objectFit="contain"
            />
          ) : (
            <Building2Icon size={32} color={palette.grey['400']} />
          )}
        </div>
      </div>
      <div style={{ minWidth: 0 }}>
        <Typography variant="body2" sx={text.ellipsis}>
          {organisation?.name}
        </Typography>
        <div
          style={{
            ...text.caption,
            ...text.ellipsis,
            color: palette.text.secondary,
          }}
        >
          {[organisation?.street, organisation?.street_number].join(' ')}
        </div>
        <div
          style={{
            ...text.caption,
            ...text.ellipsis,
            color: palette.text.secondary,
          }}
        >
          {[organisation?.postcode, organisation?.locality].join(' ')}
        </div>
      </div>
    </div>
  );
};
